<template>
  <v-text-field
    max-length="60"
    :id="idProp"
    v-model="formInput.$model"
    :disabled="disabled"
    :label="label || ($t && $t('L_contact_message_subject')) || 'Subject'"
    :autocomplete="disableAutocomplete ? 'off' : null"
    :color="color"
    :append-icon="icon"
    :error-messages="errorMessages"
    @update:model-value="onInput"
    :aria-describedby="describers"
  >
    <template #append>
      <FieldIcon :form-field="formInput" />
    </template>
  </v-text-field>
</template>

<script lang="ts">
import { defineComponent, type ComponentOptions } from 'vue';
import FieldIcon from '@/components/FieldIcon/FieldIcon.vue';
import BaseTextField from '../BaseTextField.vue';

const componentOptions: ComponentOptions = {
  name: 'SubjectInput',
  components: { FieldIcon },
  extends: BaseTextField,
  props: {
    idProp: {
      type: String,
      required: false,
      default: 'subject',
    },
  },
  data: () => ({
    modelName: 'subject',
    subject: '',
  }),
};

export default defineComponent(componentOptions);
</script>
